/*
 * @Author: Michael
 * @Date: 2019-03-13 10:54:39
 * @Last Modified by: wufan
 * @Last Modified time: 2020-06-23 19:41:58
 * 微信分享注册
 */
import fetch from '@/common/api/fetch';
import store from '@/store';
import getUrlParam from '@/common/utils/getUrlParam';
import { AxiosPromiseData, ShareObjectInterface } from '@/common/interface';
import { wechatSignUp, wechatPreviewSignUp } from '@/common/utils/wechatFunc';

interface VierParam {
  openId: string,
  activityId: string|undefined
}



// 获取微信签名， 参数为当前页面的url
export default function getViewerDetail(): Promise<any> {

  const param: VierParam = {
    openId: store.state.openId,
    activityId: getUrlParam('broadcastId')
  };
  return new Promise((resolve, reject) => {
    fetch.pureUrl('sales/anon/pose/getViewerDetail', param).then((res: AxiosPromiseData): void => {
      if (res.result) {
        store.dispatch('changeIsAgain', true)
      } else {
        store.dispatch('changeIsAgain', false)
      }
    })
  })
}